import React from 'react';
import { cn } from '@core-ui-lib/utils';

import type { WizardStep } from '../types/wizard.types';

interface WizardStepperProps {
  currentStep: WizardStep;
  onStepClick?: (step: WizardStep) => void;
}

export default function WizardStepper ({
  currentStep,
  onStepClick,
}: WizardStepperProps): React.JSX.Element {
  const steps: WizardStep[] = [1, 2, 3, 4, 5];

  const handleStepClick = (step: WizardStep): void => {
    if (onStepClick !== undefined && step < currentStep) {
      onStepClick(step);
    }
  };

  return (
    <div data-qa-id="wizard-stepper" className="flex items-center justify-center gap-0 py-4">
      {steps.map((step, index) => (
        <React.Fragment key={step}>
          {/* Step Circle */}
          <button
            type="button"
            onClick={() => {
              handleStepClick(step);
            }}
            disabled={step > currentStep}
            className={cn(
              'flex h-8 w-8 items-center justify-center rounded-full text-sm font-semibold transition-colors',
              step < currentStep && 'cursor-pointer bg-emerald-500 text-white hover:bg-emerald-600',
              step === currentStep && 'bg-emerald-500 text-white',
              step > currentStep && 'bg-muted text-muted-foreground cursor-not-allowed',
            )}
          >
            {step}
          </button>

          {/* Connector Line */}
          {index < steps.length - 1 && (
            <div
              className={cn(
                'h-1 w-16 sm:w-20 md:w-32 transition-colors',
                step < currentStep ? 'bg-emerald-500' : 'bg-muted',
              )}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
